// removed by extract-text-webpack-plugin
module.exports = {"loading-container":"loading-component__loading-container__1EtiB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/LoadingComponent/loading-component.scss
// module id = 1729
// module chunks = 1